import { CommonModule } from '@angular/common'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { NgModule } from '@angular/core'
import { SePersonaPickerFeatureAddGuardianModalModule } from '@se-po/se-persona-picker-feature-add-guardian-modal'
import { SharedFeatureEditPersonaModalModule } from '@se-po/shared-feature-edit-persona-modal'
import { SharedFeatureHouseholdInviteModule } from '@se-po/shared-feature-household-invite'
import { SharedFeatureHouseholdReviewModule } from '@se-po/shared-feature-household-review'
import { SharedUiAddChildContactInfoModule } from '@se-po/shared-ui-add-child-contact-info'
import { SharedUiAddChildProfileModule } from '@se-po/shared-ui-add-child-profile'
import { SharedUiPersonaPickerModule } from '@se-po/shared-ui-persona-picker'
import { SeFeChipModule } from 'se-fe-chip'
import { SeFeIconModule, seFeIconPlusCircleOutline } from 'se-fe-icon'
import { SeFeModalModule } from 'se-fe-modal'
import { SeFeToastModule } from 'se-fe-toast'

import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { PersonaPickerComponent } from './persona-picker/persona-picker.component'
import { AddProfileModalComponent } from './add-profile-modal/add-profile-modal.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeChipModule,
    SeFeModalModule,
    SeFeIconModule.include([
      seFeIconPlusCircleOutline
    ]),
    SeFeToastModule,
    SePersonaPickerFeatureAddGuardianModalModule,
    SharedFeatureEditPersonaModalModule,
    SharedFeatureHouseholdInviteModule,
    SharedFeatureHouseholdReviewModule,
    SharedUiAddChildContactInfoModule,
    SharedUiAddChildProfileModule,
    SharedUiPersonaPickerModule,
  ],
  declarations: [
    PersonaPickerComponent,
    AddProfileModalComponent
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi())
  ],
  exports: [PersonaPickerComponent],
})
export class SePersonaPickerFeaturePersonaPickerModule { }
